module.exports = __webpack_public_path__ + "static/media/undraw_Mobile_app.07b19705.svg";